import Vue from 'vue';
import store from '@/store';
import Actions from '@/config/actions';

Vue.mixin({
  methods: {
    parseErrorResponse(response) {
      if(!response)
      {
        return this.errors.push('Something went wrong. Please try again.');
      }
      if (response.status === 401) {
        store.dispatch(Actions.auth.LOGOUT);
        return this.$router.push('/');
      } else if (response.status === 404) {
        return this.$router.push('/404');
      } else if (response.status === 503) {
        store.dispatch(Actions.auth.LOGOUT);
        return this.$router.push('/');
      }
      else if (response.status === 500){
        return this.errors.push('Something went wrong. Please try again.');
      }

      const responseData = response.data.data || response.data;
      let error;
      if (responseData) {
        error = typeof responseData === typeof {} ? responseData.error_description : responseData;
      } else {
        error = 'Something went wrong. Please try again.';
      }
      return this.errors.push(error);
    },
    changeBodyBackground() {
      document.getElementsByTagName('body')[0].style.background = '#F0F5F7';
    },
    changeBodyToWhite(){
      document.getElementsByTagName('body')[0].style.background = '#FFFFFF';
    }
  },
});
